import { Component } from '@angular/core';
import { environment } from '../environments/environment';
import { JsonReturn } from './shared/interface/generic-interface';
import { ApiConService } from './shared/api-con.service';
import { NgIf } from '@angular/common';
import { DashboardComponent } from './dashboard/dashboard.component';
import { IdentityApiTargetService } from './shared/identity-api-target.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: true,
    imports: [NgIf, DashboardComponent]
})
export class AppComponent {
  title = 'app';
  acessoLiberado = false;

  constructor(private apiConService: ApiConService, private apiPaineltarget : IdentityApiTargetService){}

  ngOnInit() 
  {
    this.dadosAcesso();
  }  

  async dadosAcesso()
  {
    let base, usuario,data;
    const rst = await this.apiPaineltarget.authPainelTarget();

    if(rst){

      if(rst?.code == 401)
      {
        document.body.innerHTML ="<h3>Acesso Expirado!</h3>"
        return;
      }

      if(rst?.sucesso){
        base = rst.response.dbName;
        usuario= rst.response.email;
        data = new Date().getUTCFullYear() + '-' + (new Date().getUTCMonth() + 1) + '-' + new Date().getUTCDate() + " " + new Date().getHours() + ":" + new Date().getMinutes()
      }

    }else{
        let url = new URL(window.location.href);
        base = url.searchParams.get('opc1');
        usuario = url.searchParams.get('opc3');
        data = url.searchParams.get('opc4');

        base = atob(base!);
        usuario = atob(usuario!);
        data = atob(data!);

        let dataAcesso = new Date(data);
        let diferenca = new Date().getTime() - dataAcesso.getTime();

        if(diferenca > 36000000)
        {
          document.body.innerHTML ="<h3>Acesso Expirado!</h3>"
          return;
        }
    }
    
    if(base != null && base != '' && usuario != null && usuario != '' && data != null && data != '')
    {
      environment.baseDados = base;
      environment.usuarioLogado = usuario;

      let retorno: JsonReturn = await this.configInicial()
      if(!retorno.sucesso)      {
        document.body.innerHTML =`
            <div id='conteudo' style='display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100vh;background: #fff'>
            <img src='/assets/img/logo_logistica.svg' alt='logo' style='width: 217px; height: 152px;'>
            <h1 class="mt-4 text-center"> ${retorno.msg} </h1>
            <h3 class="mt-3 text-center">Entre em contato com o suporte.</h3>
          </div>`;
        return;
      }
      this.acessoLiberado = true
    }
    else
    {
      document.body.innerHTML ="<h3>Acesso Negado!</h3>"
      return;
    }
  }

  private async configInicial(): Promise<JsonReturn> {
    return await this.apiConService.patchInit();   
  }
}
